/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonEpochInfo = {
    EPHNUM: string;
    STAT: BabylonEpochInfo.STAT;
    FIRBLKNUM: string;
    FPCNT: string;
    AGE: string;
    UT: number;
};

export namespace BabylonEpochInfo {

    export enum STAT {
        NONE = 'NONE',
        SEALED = 'SEALED',
        SUBMITTED = 'SUBMITTED',
        CONFIRMED = 'CONFIRMED',
        FINALIZED = 'FINALIZED',
        ACCUMULATING = 'ACCUMULATING',
        FORGOTTEN = 'FORGOTTEN',
    }


}

